import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { Feedback } from '../../components/Feedback/Feedback'
import { InnerHero } from '../../components/InnerHero/InnerHero'
import { NewAnonceList } from '../../components/NewAnonceList/NewAnonceList'
import { NewCardsCollection } from '../../components/NewCardsCollection/NewCardsCollection'
import { NewProfit } from '../../components/NewProfit/NewProfit'
import { NewThematicContent } from '../../components/NewThematicContent/NewThematicContent'
import { Layout } from '../../components/UI/Layout/Layout'
import { NewBanner } from '../../components/UI/NewBanner/NewBanner'
import { collectionsData } from '../../consts/collectionPageData'
import { selectionCardData } from '../../consts/selectionCardData'
import {
  shuffleArrayExceptLast,
  shuffleArrayExceptLastTwo,
} from '../../helpers/randomArray'
import { setCSSVariable } from '../../helpers/setVariable'
import { setPageName } from '../../store/page/actions'
import { fetchSelectionsRequest } from '../../store/selections/actions'
import { getSelectionsWithStatus } from '../../store/selections/selectors'
import { DataProps } from './NewCollectionPage.types'

export const NewCollectionsPage = () => {
  const { id } = useParams()
  const [data, setData] = useState<DataProps>()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selections: any = useSelector(getSelectionsWithStatus)

  useEffect(() => {
    if (id) {
      const collectionData: DataProps =
        collectionsData.collections[Number(id) - 1]

      if (collectionData && !collectionData.disable) {
        setData(collectionData)
      } else {
        navigate('/')
      }
    }

    dispatch(setPageName('collection'))
    setCSSVariable('--body-bg', '#fff')
    window.scrollTo(0, 0)
    dispatch(fetchSelectionsRequest(id as string))
    return () => {
      setCSSVariable('--body-bg', '#f7f7f5')
    }
  }, [id])

  return (
    <Layout isWhite={data?.darkTheme} darkTheme={data?.darkTheme}>
      {data?.id && (
        <>
          <InnerHero
            title={data.about.title}
            text={data.about.text}
            image={data.about.imagePath}
            video={data.about.video}
            classModifiers={data?.darkTheme ? ['dark'] : []}
          />
          <NewProfit
            title={data.profit.title}
            text={data.profit.text}
            dark={data?.darkTheme}
          />
          {data?.thematicContent && (
            <NewThematicContent
              data={data?.thematicContent}
              darkTheme={data?.darkTheme}
              footnote={data?.footnote}
            />
          )}
          {data.tables && (
            <NewCardsCollection
              title={data.tables.title}
              cards={selections}
              SelectionId={Number(id)}
              showALL={true}
              noMetro={data.noMetro}
              linkLastCard={data.linkLastCard}
              type={data.type}
            />
          )}
          <NewBanner bannerNumber={data.bannerNumber} pageType='main' />
          {!data.noAnonce && (
            <NewAnonceList
              items={shuffleArrayExceptLastTwo(selectionCardData)}
              title='Все подборки'
              category='/collections/'
              id='#selections'
              exclude={id}
              currentPage={id}
            />
          )}
          {!data.noFeedback && <Feedback />}
        </>
      )}
    </Layout>
  )
}
